import React, { useEffect, useState } from 'react';
import { FontIconBtn, Tooltip } from '@meitu/saas-ui';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

const RedoAndUndo = () => {
    const { $t } = useLocaleStore();

    const [operate, setOperate] = useState({
        isMain: true,
        canRedo: false,
        canUndo: false,
    });

    const [isDisableOperate, setIsDisableOperate] = useState(false);

    useEffect(() => {
        // 编辑器状态监听
        return editor.onState(({ disableOperate, disablePick }) => {
            setIsDisableOperate(disableOperate || disablePick);
        });
    }, []);

    useEffect(() => {
        // 监听历史记录变更
        const changeHandler = editor.history.onChange(({ isMain, canRedo, canUndo }) => {
            setOperate({ isMain, canRedo, canUndo });
        });

        return () => {
            editor.off(changeHandler);
        };
    }, []);

    return (
        <>
            <Tooltip placement="bottom" title={$t((v) => v.header.undo)}>
                <div className="p-header__undo">
                    <FontIconBtn
                        onClick={() => {
                            editor.history.undo();
                        }}
                        disable={!operate.canUndo || (operate.isMain && isDisableOperate)}
                        type="button"
                        name="UndoBold"
                        fontSize={16}
                    />
                </div>
            </Tooltip>
            <Tooltip placement="bottom" title={$t((v) => v.header.redo)}>
                <div className="p-header__redo">
                    <FontIconBtn
                        onClick={() => {
                            editor.history.redo();
                        }}
                        disable={!operate.canRedo || (operate.isMain && isDisableOperate)}
                        type="button"
                        name="RedoBold"
                        fontSize={16}
                    />
                </div>
            </Tooltip>
        </>
    );
};

export default React.memo(RedoAndUndo);
